import React from "react"
import { Modal } from "./Modal"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import L10n from "../../../lib/carrot-l10n"
import { Body } from "../atoms/Bodies"
import { Spacer } from "../atoms/Atoms"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const UpdateYourContactModal = ({ onExit }) => {
  return (
    <Modal underlayClickExits={false} onExit={onExit} titleText={l`Update your contact information`}>
      <div className="tl ph45 mw-600">
        <H2 variant="primary">{l`Update your contact information`}</H2>
        <Spacer height={1} />
        <Body>{l`To add a preferred contact email or a partner’s email visit your Account Settings.`}</Body>
        <hr className="w-100 mv35 center b--black-05" />
        <ButtonPrimary to="/account#Personal information">{l`Update now`}</ButtonPrimary>
        <Spacer height={2} />
      </div>
    </Modal>
  )
}

export default UpdateYourContactModal
